import { Component, ViewEncapsulation } from '@angular/core';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { PolicyService } from '@core/services/policy.service';
import { InactiveProduct } from '@shared/models/inactive-product';
import { Policy } from '@shared/models/policy';
import { PoliciesComponent } from '../policies.component';
import { LoadingService } from '@core/services/loading.service';

@Component({
    selector: 'app-policies-overview',
    templateUrl: './policies-overview.component.html',
    styleUrls: ['./policies-overview.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PoliciesOverviewComponent extends PoliciesComponent {

  public activePolicies: Policy[];
  public inactivePolicies: Policy[];
  public inactiveProducts: InactiveProduct[];
  public specialOffer: InactiveProduct;
  public selectedIndex = 0;

  constructor(
    public commonService: CommonService,
    protected dataService: DataService,
    protected policyService: PolicyService,
    protected loadingService: LoadingService
  ) {
    super(commonService, dataService, policyService);

    this.inactiveProducts = dataService.inactiveProducts;
    this.specialOffer = this.inactiveProducts.find(x => x.name === this.lob.TravelInsurance);
  }


  tabChanged(index): void {
    this.selectedIndex = index;
    if (index === 1 && !this.inactivePolicies) {
      this.policyService.getInactivePolicies().subscribe(res => {
        this.inactivePolicies = res.sort((a, b) => new Date(b.effectiveFromDate).getTime() - new Date(a.effectiveFromDate).getTime());
      });
    }
  }
}
